<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
export default {
  name: 'MemberListPage',
  data () {
    return {
      columnConfig: [
        {
          columnCode: 'firstName',
          columnName: 'First Name',
          align: 'left',
          value: item => {
            return item.firstName
          }
        },
        {
          columnCode: 'lastName',
          columnName: 'Last Name',
          align: 'left',
          value: item => {
            return item.lastName
          }
        },
        {
          columnCode: 'email',
          columnName: 'Email',
          align: 'left',
          value: item => {
            return item.email
          }
        },
        {
          columnCode: 'roleCode',
          columnName: 'Role',
          align: 'left',
          value: item => {
            return item.roleCode
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('member/list', payload)
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/member/MemberListPage.vue